<template>
  <div :class="`(customClass) ? ${customClass} : 'text-xs-center pt-3'`">
    <v-menu
      ref="menu"
      lazy
      :close-on-content-click="false"
      v-model="menu"
      transition="scale-transition"
      offset-y
      full-width
      :nudge-right="40"
      max-width="290px"
      min-width="290px"
      :disabled="isDisabled"
      :return-value.sync="date"
    >
      <template v-slot:activator="{ on }">
        <v-text-field 
          :value="formatted"
          :label="label"
          append-icon="event"
          :error="error"
          readonly
          :disabled="isDisabled"
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker
        type="date"
        v-model="date"
        @input="onDateSelect(date)"
        :required="required"
        no-title
        scrollable
      >
        <v-spacer></v-spacer>
        <v-btn flat color="warning" @click="onDateSelect(null)">Clear</v-btn>
      </v-date-picker>
    </v-menu>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'ChipDatePicker',
  props: [ 'value', 'label', 'customClass', 'isDisabled', 'error', 'required' ],
  data () {
    return {
      date: this.value,
      menu: false
    }
  },
  computed: {
    formatted () {
      return (this.date) ? moment(this.date).format('DD/MM/YYYY') : ''
    }
  },
  methods: {
    onDateSelect (val) {
      this.date = val
      this.menu = false
      this.$refs.menu.save(val)
      this.$emit('input', this.date)
    }
  },
  watch: {
    value () {
      this.date = this.value
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/date-picker/NChipDatePicker.vue